import { ReadAiArkBootstrapResponse } from '@aibees/elephant/types/bootstrap';
import { useBootstrapApiBase } from '@aibees/shared/api';
import { useDebounceFn } from '@aibees/shared/hooks';
import { LabelUpdatesSocketMessage } from '../labels/types';
import { useSocketLabelUpdateListener } from '../labels/use-socket-label-update-listener';

export function useBootstrapApi() {
  const api = useBootstrapApiBase<ReadAiArkBootstrapResponse>();

  const onLabelUpdateEvent = useDebounceFn(
    (_data: LabelUpdatesSocketMessage) => {
      api.debouncedRefetch();
    },
    1000
  );

  useSocketLabelUpdateListener(onLabelUpdateEvent);

  return api;
}
